/**
 * Costanti per i campi prodotto del modulo flyers
 * @module flyers/constants/fields
 */

/**
 * Set di chiavi per i campi prezzo che richiedono normalizzazione speciale
 */
export const PRICE_FIELD_KEYS = new Set([
    "prezzo_base",
    "prezzo_iniziale_grammatura",
    "prezzo_offerta",
    "prezzo_offerta_um"
]);

/**
 * Set di campi AI che sono array multipli
 */
export const MULTI_AI_FIELDS = new Set(["bollino", "meccanica", "filtro"]);

// Suggerimento sul campo Seriale (sola lettura) nell'editor card: il seriale è l'identità della
// card e si modifica solo in pre-elaborazione, prima che l'AI crei la card.
export const SERIAL_READONLY_HINT = "Il seriale si modifica in pre-elaborazione (tasto destro sulla gabbia → Modifica seriale), prima dell'elaborazione AI";
